import React from 'react';
import classNames from 'classnames';
import { useIdle } from '../../hooks';
import { IDLE_SCHEDULE } from '../../constants';
import './Header.scss';
const Header = ({ leftControls, rightControls, title, }) => {
    const { isIdle } = useIdle(IDLE_SCHEDULE);
    const controlItemMapper = (el, i) => {
        return (<div key={i} className="ml-header__controls-item">
        {el}
      </div>);
    };
    return (<div className={classNames({
            'ml-header': true,
            'ml-header--hidden': isIdle,
        })}>
      <div className="ml-header__controls ml-header__controls--left">
        {leftControls.map((el, i) => controlItemMapper(el, i))}
      </div>
      <div className="ml-header__title">{title}</div>
      <div className="ml-header__controls ml-header__controls--right">
        {rightControls.map((el, i) => controlItemMapper(el, i))}
      </div>
    </div>);
};
export default Header;
